import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import moment from "moment";
import { openCloseModalEditWeek, doUpdateWeekAppointment, setAppointmentEditWeek } from "./actions";
import { ModalTitleSteps } from "../../../../Shared/ModalTitleSteps";
import NumberField from "../../../../Shared/fields/NumberField";
import TagField from "../../../../Shared/fields/TagField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import OpeningValidation from "./wizard/openigValidation";

class ModalEditWeek extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isOpenModalEditWeek && !prevProps.isOpenModalEditWeek) {
      this.setState({ currentStep: 1 });
    }
  }

  handleChange = (e, isConfig = false) => {
    const newData = { ...this.props.appointmentEditWeek };
    if (isConfig) {
      newData.config[e.element.id] = e.value;
    } else {
      newData[e.element.id] = e.value;
    }
    this.props.dispatch(setAppointmentEditWeek(newData));
  }

  handleChangeCupos = (e, quotaType, ammountType) => {
    const newData = { ...this.props.appointmentEditWeek };
    const editedQuotas = newData.Quotas.map((q) => {
      if (q.Quota.Description === quotaType) {
        const newQ = { ...q };
        newQ[ammountType] = e.value;
        return newQ;
      }
      return q;
    });

    newData.Quotas = editedQuotas;

    this.props.dispatch(setAppointmentEditWeek(newData));
  }

  handleNext = () => {
    if (this.state.currentStep === 2) {
      this.handleSave();
    } else {
      this.setState({ currentStep: 2 });
    }
  }

  handleClose = () => {
    this.props.dispatch(openCloseModalEditWeek(false, { config: {} }));
  }

  handleSave = () => {
    this.props.dispatch(doUpdateWeekAppointment(this.props.appointmentEditWeek));
  }

  renderStep1 = (appointment) => (
    <React.Fragment>
      {appointment.Quotas && appointment.Quotas.map((item) => (
        <div className="row" key={item.Quota.Description}>
          <div className="col-6">
            <NumberField
              id={`cupos${item.Quota.Description}`}
              label={item.Quota.Description}
              min={0}
              value={appointment[`cupos${item.Quota.Description}`] || item.AmmountQuota}
              onChange={(data) => this.handleChangeCupos(data, item.Quota.Description, "AmmountQuota")}
              showSpinButtons
            />
          </div>
          <div className="col-6">
            <NumberField
              id={`sobreCupo${item.Quota.Description}`}
              min={0}
              max={item.Quota.OverbookedMaximumAmount}
              label={`Sobrecupo ${item.Quota.Description}`}
              value={appointment[`sobreCupo${item.Quota.Description}`] || item.AmmountOverQuota}
              onChange={(data) => this.handleChangeCupos(data, item.Quota.Description, "AmmountOverQuota")}
              showSpinButtons
            />
          </div>
        </div>
      ))}

      <div className="row">
        <div className="col-12" style={{ display: "flex", alignItems: "baseline" }}>

          <div style={{ marginRight: 10 }}>
            Aplicar a todos {moment(appointment.startDate).format("dddd")} los de la partura
          </div>

          <SwitchField
            visible
            id="todaApertura"
            switchedOffText="No"
            switchedOnText="Si"
            onChange={this.handleChange}
            value={appointment.todaApertura}
          />
        </div>
      </div>
    </React.Fragment>
  );

  renderStep2 = (appointment) => (
    <React.Fragment>
      <div style={{ textAlign: "center", marginTop: 30 }}>
        Baterías y prestaciones disponibles durante el módulo
      </div>

      <TagField
        dataSource={this.props.listExamPools}
        value={appointment.config ? appointment.config.Pools : []}
        label="Baterías"
        onChange={(e) => this.handleChange(e, true)}
        maxDisplayedTags={2}
        showMultiTagOnly={false}
        displayExpr="Name"
        valueExpr="id"
        id="Pools"
      />
      <TagField
        dataSource={this.props.listExams}
        value={appointment.config ? appointment.config.Exams : []}
        label="Prestaciones SEP"
        onChange={(e) => this.handleChange(e, true)}
        displayExpr="Name"
        maxDisplayedTags={2}
        showMultiTagOnly={false}
        valueExpr="id"
        id="Exams"
      />
      <TagField
        dataSource={this.props.listCiel}
        value={appointment.config ? appointment.config.Ciel : []}
        label="Prestaciones CIEL"
        onChange={(e) => this.handleChange(e, true)}
        maxDisplayedTags={2}
        showMultiTagOnly={false}
        displayExpr="Name"
        valueExpr="id"
        id="Ciel"
      />
    </React.Fragment>
  )

  renderWizard = () => {
    const appointment = { ...this.props.appointmentEditWeek };
    return (
      <div className="cupos-edit-wrapper">
        {this.props.isLoading && <LoadingOverlay />}
        {this.state.currentStep === 1 && this.renderStep1(appointment)}
        {this.state.currentStep === 2 && this.renderStep2(appointment)}

        <div className="button-row">
          <div>
            <Button
              text="Cancelar"
              onClick={this.handleClose}
            />
          </div>
          <div>
            <Button
              text={this.state.currentStep === 2 ? "Guardar" : "Siguiente"}
              onClick={this.handleNext}
              type="success"
            />
          </div>
        </div>
      </div >

    );
  }
  render() {
    const {
      validationOpening,
    } = this.props;
    return (

      <Popup
        visible={this.props.isOpenModalEditWeek}
        dragEnabled={false}
        onHiding={this.handleClose}
        showCloseButton
        height={validationOpening.openValidation === false ? 500 : 250}
        width={600}
        titleTemplate={(element) => {
          ReactDOM.render(
            <ModalTitleSteps
              title={validationOpening.openValidation === false ? "Editar módulo" : "Conflictos"}
              currentStep={validationOpening.openValidation === false && this.state.currentStep}
              totalSteps={validationOpening.openValidation === false ? 2 : null}
              onClose={this.handleClose}
            />
            , element
          );
        }}
      >
        <div>
          {
            validationOpening.openValidation === false ? this.renderWizard() : <OpeningValidation />

          }
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.aperturasSel.isLoading,
  isOpenModalEditWeek: state.aperturasSel.isOpenModalEditWeek,
  appointmentEditWeek: state.aperturasSel.appointmentEditWeek,
  Opening: state.aperturasSel.Opening,
  listCiel: state.aperturasSel.listCiel,
  listExams: state.aperturasSel.listExams,
  listExamPools: state.aperturasSel.listExamPools,
  validationOpening: state.aperturasSel.validationOpening,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditWeek);
